import { MapPin } from 'lucide-react'

import { useCan } from '@/auth'
import { Select, Skeleton } from '@/design'
import { ALL_LOCATIONS } from '@/location/location-store'
import { useLocationScope } from '@/location/use-locations'

/**
 * The topbar's location control. Scoped roles see only their locations and never "All".
 * Hidden entirely for callers without `locations:read` (platform / reseller plane).
 */
export function LocationSwitcher() {
  const canRead = useCan('locations:read')
  const scope = useLocationScope()
  if (!canRead) return null
  if (scope.isLoading) return <Skeleton className="h-9 w-44" />
  if (scope.locations.length === 0) return null

  const options = [
    ...(scope.canChooseAll ? [{ value: ALL_LOCATIONS, label: 'All locations' }] : []),
    ...scope.locations.map((location) => ({ value: location.id, label: location.name })),
  ]
  const single = !scope.canChooseAll && scope.locations.length === 1

  return (
    <div className="flex items-center gap-2">
      <MapPin aria-hidden className="hidden size-4 text-muted sm:block" />
      <label className="sr-only" htmlFor="location-switcher">
        Location
      </label>
      <Select
        id="location-switcher"
        options={options}
        value={scope.selectedId ?? ''}
        disabled={single}
        onChange={(event) => {
          scope.select(event.target.value)
        }}
        className="h-9 w-[180px] sm:w-[220px]"
      />
    </div>
  )
}
